import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';
import { LayoutModule } from '../layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { LegalNoticeButtonsComponent } from './components/legal-notice-buttons/legal-notice-buttons.component';
import { LegalNoticePageComponent } from './components/legal-notice-page/legal-notice-page.component';

@NgModule({
  declarations: [
    LegalNoticePageComponent,
    LegalNoticeButtonsComponent,
  ],
  imports: [
    CommonModule,
    MarkdownModule,
    TranslateModule,
    RouterModule,
    LayoutModule,
    SharedModule,
  ],
  exports: [
    LegalNoticeButtonsComponent,
  ],
})
export class LegalNoticeModule { }
